// @flow
import React, { Component } from 'react';
import { getSolWrapper } from './';

type Props = {
  requiresSolMonitor: Boolean,
  solMetadata: *
};

const withSolImpressionTracker = (
  WrappedComponent: Class<React$Component<*, *>>
) => {
  const {
    monitorSearchImpression,
    monitorSearchImpressionOff
  } = getSolWrapper();

  return class SolTracker extends Component<Props> {
    constructor(props: *) {
      super(props);

      const { solMetadata, requiresSolMonitor } = this.props;
      this.solMetadata = solMetadata;
      this.requiresSolMonitor = requiresSolMonitor;
      this.solDivRef = React.createRef();
    }

    componentDidMount() {
      if (this.requiresSolMonitor) {
        monitorSearchImpression(this.solDivRef.current, this.solMetadata);
      }
    }

    componentWillUnmount() {
      monitorSearchImpressionOff(this.solDivRef.current, this.solMetadata);
    }

    solDivRef: { current: null | HTMLDivElement };
    requiresSolMonitor: Boolean;
    solMetadata: *;

    render() {
      return (
        <div
          ref={this.solDivRef}
          data-sol-meta={JSON.stringify(this.solMetadata || {})}
        >
          <WrappedComponent {...this.props} />
        </div>
      );
    }
  };
};

export default withSolImpressionTracker;
